import { reportLengths } from '@/lib/consts'
import demo1 from './demo1'
import demo2 from './demo2'
import demo3 from './demo3'

export default {
  state: {
    numCompleted: 0
  },
  mutations: {
    incrementDemosCompleted ( state ) {
      if ( state.numCompleted < 3 ) state.numCompleted++
    }
  },
  actions: {
    setDemoComplete ( { commit, state, dispatch }, idx ) {
      commit( `demo${idx}/setComplete`, true )
      commit( 'incrementDemosCompleted' )
      if ( state.numCompleted >= 2 ) {
        dispatch( 'setReportLength', reportLengths.long )
      }
    },
    enableDemo ( { commit }, idx ) {
      commit( `demo${idx}/setEnabled`, true )
      if ( idx > 1 ) {
        while ( --idx >= 1 ) {
          commit( `demo${idx}/setEnabled`, true )
        }
      }
    },
    disableDemo ( { commit }, idx ) {
      commit( `demo${idx}/setEnabled`, false )
    },
    activateDemo ( { commit }, idx ) {
      commit(`demo${idx}/activate`)
    },
    deactivateDemo ( { commit }, idx ) {
      commit(`demo${idx}/deactivate`)
    }
  },
  modules: {
    demo1,
    demo2,
    demo3
  }
}



// WEBPACK FOOTER //
// ./src/store/demos/index.js